module.exports = __webpack_public_path__ + "static/img/typograph@w.1ff69fd.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hanssem/typograph@w.gif
// module id = wb0h
// module chunks = 0